module.exports = __webpack_public_path__ + "img/but5.ae537a1c.png";